import "../formProcessing.css";
import LeftMenu from "../../AnalyticsModule/Left";
import "../../AnalyticsModule/home.css"
import "./eciReport.css"
import { Link, useNavigate } from "react-router-dom";
import { useGetStateWiseEpbReceviedByROReportQuery, useGetstateWiseScanningCompletedReportQuery, useGetstateWiseSummaryReportQuery } from "../../../services/reportsServices";
import { useEffect, useState } from "react";
import { downloadExcelFile } from "../../utilities/utils";
import { RunnerUpHeader } from "../../../ui";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const tableHeader = [
      "StateCd","StateName","ServiceVoter Count","Transmitted","Ballot Downloaded","Pin Downloaded"
]
const tableHeader2 = [
      "State Name" ,"Constituency Type" ,"Total e-PB Recieved Till Date By RO"
]
const sheetname = "StateWise Summary Report"
const filename = "State-Wise Summary Report"
const sheetname1 = "State Wise e-PB Recieved Till Date By RO"
const filename1 = "State Wise e-PB Recieved Till Date By RO"

function EciReports() {
      let navigate = useNavigate();
      const [getData,setData] = useState(true)
      const [getData1,setData1] = useState(true)

      const {data,isSuccess} = useGetstateWiseSummaryReportQuery("",{skip:getData})
      const {data:data1,isSuccess:isSuccess1} = useGetStateWiseEpbReceviedByROReportQuery("",{skip:getData1})
      // const {data:scanningCompleted,isSuccess:dataScanned} = useGetstateWiseScanningCompletedReportQuery()
      const [tableData,setTableData] = useState([])
      const [tableData2,setTableData2] = useState([])
      // console.log(scanningCompleted)

      useEffect(()=>{
            if(isSuccess){
                  let record = []
                  data?.payload?.map((item,i)=>{
                        record.push({
                              stateCd:item?.stateCd,
                              stateName:item?.stateName,
                              serviceVoterCount:item?.serviceVoterCount,
                              transmitted:item?.transmitted,
                              ballotDownloaded:item?.ballotDownloaded,
                              pinDownloaded:item?.pinDownloaded,
                              // epbBooked:item?.epbBooked,
                        })
                  })
                  setTableData(record)
                  setData(true)
            }
            if(tableData.length>0){
                  downloadExcelFile(filename,sheetname,tableHeader,tableData,true)
            }
      },[isSuccess,data])

      useEffect(()=>{
            if(isSuccess1){
                  console.log("hi")
                  let record = []
                  data1?.payload?.map((item,i)=>{
                        record.push({
                              stateName:item?.stateName,
                              constType:item?.constType,
                              totalEpbRecievedTillDateByRo:item?.totalEpbReceviedByRO,
                        })
                  })
                  setTableData2(record)
                  setData1(true)
            }
            if(tableData2.length>0){
                  downloadExcelFile(filename1,sheetname1,tableHeader2,tableData2)
            }
      },[isSuccess1,data1])


      
      // useEffect(()=>{
      //       if(dataScanned){
      //             const a3 = scanningCompleted?.payload?.scanningTotalAcDetails?.map(t1 => ({...t1, ...scanningCompleted?.payload?.scanningTotalScansDetails?.find(t2 => t2.stateName === t1.stateName)}))

      //             let data = []
      //             a3?.map((item,i)=>{
      //                   data.push({
      //                         // SNo:i+1,
      //                         // stateCd:item?.stateCd,
      //                         stateName:item?.stateName,
      //                         TotalAcs:item?.totalAcs,
      //                         TotalAcsCompletedPrecounting:item?.total_scanning_completed,
      //                         TotalServiceVoter:item?.totalServiceVoters,
      //                         TotalEpbTransmitted:item?.totalEpbTransmitted,
      //                         TotalEpbDownloaded:item?.totalEpbDownloaded,
      //                         TotalePBBooked:item?.totalEpbBooked,
      //                         TotalePBReceivedtill8AM:item?.epb_Receiceived_Till_8AM,
      //                         ValidePB:item?.validCount,
      //                         InvalidePB:item?.invalidCount,
      //                         DuplicateePB:item?.duplicateCount,
      //                         ManuallyRejectedePB:item?.manualInvalidCount,
      //                         TotalePBScanned:parseInt(item?.invalidCount) +parseInt(item?.manualInvalidCount) +parseInt(item?.validCount) +parseInt(item?.duplicateCount),
      //                   })
      //             })
      //             setTableData2(data)
      //       }
      // },[dataScanned,scanningCompleted])

      return (
            <>
                  <LeftMenu>
                        <div className="container-fluid p-2 box reports">
        <RunnerUpHeaderNew title="e-PB Transmission Report" />

                              <div className="row">
                                    <div class="col-md-4">
                                          <div class="card l-bg-cherry">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/eci/report/epb-generation-eci-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-envelopes-bulk mr-2"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                        e-Postal Ballot Transmission Report
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class="col-md-4">
                                          <div class="card l-bg-yellow-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/eci/report/phaseWise-ePBTransmission-eci-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-map-location-dot mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                        Phase Wise e-PB Transmission Report
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                   
                                    
                                    </div>
                                    <RunnerUpHeaderNew title="e-PB Downloading Report" />
                                    <div className="row">
                                  
                                    <div class="col-md-4">
                                          <div class="card l-bg-green-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/eci/report/epb-downloading-statewise-eci-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-map-location-dot mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                        e-Postal Ballot Downloading Report State Wise
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class="col-md-4">
                                          <div class="card l-bg-blue-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/eci/report/epb-downloading-forcewise-eci-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-download mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                        e-Postal Ballot Downloading Report Force Wise
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class="col-md-4">
                                          <div class="card l-bg-yellow-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/eci/report/epb-downloading-record-officewise-eci-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-person-rifle mr-2"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                        e-Postal Ballot Downloading Report Record Office Wise
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class="col-md-4">
                                          <div class="card l-bg-cyan-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/eci/report/epb-downloading-unitofficewise-eci-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-person-military-rifle mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                        e-Postal Ballot Downloading Report Unit Office Wise
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class={`col-md-4 `}>
                                          <div class="card l-bg-green-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => setData(false)}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-map-location-dot mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                        State-Wise Summary Report
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    {/* <div class={`col-md-4 `}>
                                          <div class="card l-bg-orange-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => setData1(false)}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-users-viewfinder mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                        State-Wise e-PB Received Report By RO
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div> */}
                                    <div class="col-md-4">
                                          <div class="card l-bg-cherry">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/eci/report/record-unit-pendency-eci-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-envelopes-bulk mr-2"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                  Record / Unit Pending List
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class="col-md-4">
                                          <div class="card l-bg-blue-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/eci/report/ePb-Status-PhaseWise-eci-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-map-location-dot mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                  e-Postal Ballot Downloading Report State Wise ( Phase Wise )
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    </div>
                                    <RunnerUpHeaderNew title="e-PB Pre-Counting Report" />
                                    <div className="row">
                                    <div class="col-md-4">
                                          <div class="card l-bg-orange-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/eci/report/counting-supervisor-eci-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-users-viewfinder mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                        Counting Supervisor Report
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class="col-md-4">
                                          <div class="card l-bg-grey-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/eci/report/epb-scanning-eci-report")}>
                                                      <div class="card-icon card-icon-large"><i className="fas fa-solid fa-qrcode mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                        e-Postal Ballot Pre-Counting Report
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class="col-md-4">
                                          <div class="card l-bg-blue-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/eci/report/ePb-PreCounting-Summary-eci-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-map-location-dot mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                  e-Postal Ballot Pre-Counting Summary Report
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class="col-md-4">
                                          <div class="card l-bg-green-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/eci/report/epb-precounting-completion-statewise-eci-report")}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-map-location-dot mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                        e-Postal Ballot Pre-Counting Completion State Wise Report
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    {/* <div class={`col-md-4 ${dataScanned ? "":"disabledDivReport"}`}>
                                          <div class="card l-bg-orange-dark">
                                                <div class="card-statistic-3 p-4 card-height-reports" onClick={() => downloadExcelFile(filename1,sheetname1,tableHeader2,tableData2,true)}>
                                                      <div class="card-icon card-icon-large"><i class="fas fa-solid fa-map-location-dot mr-3"></i></div>
                                                      <div class="row align-items-center mb-2 d-flex">
                                                            <div class="col-10 card-text-alignment ">
                                                                  <h5 class="d-flex align-items-center mb-0">
                                                                  State Wise e-PB Transmission, Downloading and Pre-Counting Report
                                                                  </h5>
                                                            </div>
                                                      </div>
                                                </div>
                                          </div>
                                    </div> */}
                                    </div>
                                    <div className="row">
                              
                                    </div>
                        </div>
                  </LeftMenu>
            </>
      );
}

export default EciReports;
